import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-900 text-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 text-xl font-heading text-background-50 mb-4">
              <span className="w-8 h-8 flex items-center justify-center">
                <i className="fa-solid fa-cat text-xl text-primary-300"></i>
              </span>
              猫咪社区
            </Link>
            <p className="text-sm text-background-300 leading-relaxed">
              {t("footer_description")}
            </p>
          </div>

          <div>
            <h4 className="text-base font-medium text-background-50 mb-4">{t("footer_links")}</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-300 hover:text-primary-300 transition-colors duration-200 whitespace-nowrap">
                  {t("home")}
                </Link>
              </li>
              <li>
                <Link to="/category/yanghu" className="text-sm text-background-300 hover:text-primary-300 transition-colors duration-200 whitespace-nowrap">
                  猫咪养护
                </Link>
              </li>
              <li>
                <Link to="/category/jiankang" className="text-sm text-background-300 hover:text-primary-300 transition-colors duration-200 whitespace-nowrap">
                  健康问答
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-300 hover:text-primary-300 transition-colors duration-200 whitespace-nowrap">
                  {t("about")}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-medium text-background-50 mb-4">{t("footer_categories")}</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/category/mengtu" className="text-sm text-background-300 hover:text-primary-300 transition-colors duration-200 whitespace-nowrap">
                  萌猫图片
                </Link>
              </li>
              <li>
                <Link to="/category/lingyang" className="text-sm text-background-300 hover:text-primary-300 transition-colors duration-200 whitespace-nowrap">
                  领养信息
                </Link>
              </li>
              <li>
                <Link to="/category/xingwei" className="text-sm text-background-300 hover:text-primary-300 transition-colors duration-200 whitespace-nowrap">
                  行为解读
                </Link>
              </li>
              <li>
                <Link to="/category/yinshi" className="text-sm text-background-300 hover:text-primary-300 transition-colors duration-200 whitespace-nowrap">
                  饮食营养
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-medium text-background-50 mb-4">{t("footer_contact")}</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-background-300">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line"></i>
                </span>
                hello@catcommunity.cn
              </li>
              <li className="flex items-center gap-2 text-sm text-background-300">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-wechat-line"></i>
                </span>
                CatCommunity_Official
              </li>
              <li className="flex items-center gap-2 text-sm text-background-300">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-map-pin-line"></i>
                </span>
                北京市朝阳区
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-400">{t("footer_copyright")}</p>
          <div className="flex items-center gap-5">
            <a href="#" className="w-8 h-8 flex items-center justify-center text-background-400 hover:text-primary-300 transition-colors duration-200" aria-label="微信">
              <i className="ri-wechat-fill text-lg"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center text-background-400 hover:text-primary-300 transition-colors duration-200" aria-label="微博">
              <i className="ri-weibo-fill text-lg"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center text-background-400 hover:text-primary-300 transition-colors duration-200" aria-label="小红书">
              <i className="ri-bilibili-fill text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}